var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-765.000000, -33.000000)",
    fill: "#54575A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(765.000000, 33.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.578125,45.553125 L35.915625,33.890625 C39.046875,30.290625 40.940625,25.603125 40.940625,20.465625 C40.940625,9.178125 31.753125,0 20.475,0 C9.178125,0 0.009375,9.1875 0.009375,20.465625 C0.009375,31.74375 9.196875,40.93125 20.475,40.93125 C25.603125,40.93125 30.3,39.0375 33.9,35.90625 L45.5625,47.56875 C45.84375,47.85 46.209375,47.990625 46.575,47.990625 C46.940625,47.990625 47.30625,47.85 47.5875,47.56875 C48.13125,47.025 48.13125,46.10625 47.578125,45.553125 Z M2.86875,20.465625 C2.86875,10.7625 10.7625,2.86875 20.465625,2.86875 C30.16875,2.86875 38.0625,10.7625 38.0625,20.465625 C38.0625,30.16875 30.178125,38.071875 20.465625,38.071875 C10.7625,38.071875 2.86875,30.16875 2.86875,20.465625 Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.9c6640c89913417c9794b0dc242fb532.svg";
export { ForwardRef as ReactComponent };